import HttpService from "@/services/HttpService";
const httpService = new HttpService();

import { FILE_UPLOAD_MAX, AUTHORIZED_FILE_TYPES } from "@/const";

export default class VerificationService {
  /**
   * get Stripe subscription plans
   * @returns
   */
  getSubscriptionPlans: any = async () => {
    console.log("getSubscriptionPlans");
    const serverResponse = await httpService.fetch(
      "GET",
      "api/payment/products",
      {}
    );
    console.log("got plans", serverResponse);
    return serverResponse.plans;
  };

  /**
   * get a session data from its id
   * @param sessionId
   */
  getSessionData: any = async (ownerId: string, sessionId: string) => {
    console.log("getSessionData gere");
    const serverResponse = await httpService.fetch(
      "GET",
      `api/payment/session/${sessionId}/owner/${ownerId}`,
      {}
    );
    console.log("response from front", serverResponse);
    return serverResponse.session;
  };

  /**
   * Function called after payment has succeeded
   * @param ownerId
   * @param paymentId
   * @param sessionId
   */
  paymentSuccess: any = async (
    ownerId: string,
    paymentId: string,
    sessionId: string
  ) => {
    console.log("payment success");

    const serverResponse = await httpService.fetch(
      "POST",
      `api/payment/success`,
      {
        paymentId,
        sessionId,
      }
    );

    console.log("success serverResponse", serverResponse);
    return serverResponse;
  };

  /**
   * Upload a verification file
   * Can be a wifi document or something like that
   * @param placeId
   * @param documentNumber
   * @param file
   */
  sendVerificationDocument: any = async (
    ownerId: string,
    placeId: string,
    documentNumber: string,
    file: File
  ) => {
    if (placeId != "" && documentNumber != "" && file) {
      // we check if file is not too big
      if (file.size > FILE_UPLOAD_MAX * 1000) {
        console.log("file too big");
        // "FILE_TOO_BIG"
        return {
          success: false,
          error: "placeDetail.verification.documents.errors.fileTooBig",
        };
      }
      // we check if file type is allowed
      if (
        !AUTHORIZED_FILE_TYPES.includes(
          file.name.split(".")[file.name.split(".").length - 1]
        )
      ) {
        // UNAUTHORIZED_FILE_TYPE
        return {
          success: false,
          error: "placeDetail.verification.documents.errors.wrongFileType",
        };
      }

      const formData = new FormData();
      console.log("send verification document", file);
      formData.append("ownerId", ownerId);
      formData.append("file", file);
      formData.append("uid", placeId);
      formData.append("documentNumber", documentNumber);

      console.log("formData", formData);

      const serverResponse = await httpService.fetch(
        "POST",
        "api/payment/verification/document",
        formData,
        {},
        { fileUpload: true }
      );
      console.log("verification doc response", serverResponse);
      return {
        success: true,
        paymentObject: serverResponse.paymentObject.paymentObject,
      };
    } else {
      return { success: false };
    }
  };

  /**
   *
   * @param ownerId
   * @param placeId
   * @param paymentId
   */
  proceedPayment: any = async (
    ownerId: string,
    placeId: string,
    paymentId: string,
    planId: string,
    formData: any
  ) => {
    console.log("proceed payment from service");
    const serverResponse = await httpService.fetch(
      "POST",
      "api/payment/proceed-payment",
      {
        ownerId,
        placeId,
        paymentId,
        planId,
        formData,
      }
    );
    console.log("from service serverResponse", serverResponse);
    if (serverResponse.redirect) {
      window.location.href = serverResponse.redirect;
    }
  };
}
